import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Master.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { AddLokasiEntity, LokasiEntity } from "../../entities/LokasiEntity";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { LokasiService } from "../../services/lokasis";

export default function MasterLokasi() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  // const [excludeFilter, setExcludeFilter] = useState();
  // const [tableDataFilter, setTableDataFilter] = useState({});

  const [tableData, setTableData] = useState<LokasiEntity[]>([]);

  const [selectedLokasi, setSelectedLokasi] = useState<LokasiEntity | null>(null);
  const [selectedAddLokasi, setSelectedAddLokasi] = useState<AddLokasiEntity | null>(null);

  const [showPopup, setShowPopup] = useState(false);

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleAddNew = () => {
    setSelectedAddLokasi(null);
    setSelectedLokasi(null);
    setShowPopup(true);
  }

  const handlePopupDetail = (row: LokasiEntity) => {
    setSelectedLokasi(row);
    setShowPopup(true)
  }

  const handleSaveAddLokasi = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedAddLokasi == null || selectedAddLokasi.lokasi == null) { throw new Error("invalid lokasi") }
      const resp = await LokasiService.AddLokasi({ lokasi: selectedAddLokasi.lokasi });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedLokasi(null);
      setSelectedAddLokasi(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSaveUpdateLokasi = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedLokasi == null) { throw new Error("invalid selected lokasi") }
      const resp = await LokasiService.UpdateLokasi(selectedLokasi, { lokasi: selectedLokasi.lokasi });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedLokasi(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleDeleteLokasi = async () => {
    return contextShowAlertFunc(new AlertEntity({
      message: `Apakah anda yakin ingin menghapus ${selectedLokasi?.lokasi} ?`,
      onOk: async () => {
        contextShowLoadingFunc(true);
        try {
          if (selectedLokasi == null) { throw new Error("invalid selected lokasi") }
          const resp = await LokasiService.DeleteLokasi(selectedLokasi);
          await generateData();
          contextShowLoadingFunc(false);
          setSelectedLokasi(null);
          setShowPopup(false);
          contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
          contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
          contextShowLoadingFunc(false);
        }
      },
      withCancel: true,
      withOk: true,
      level: 2
    }))
  }

  const handleGenerateExcel = async () => {
    if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
    const column = ["lokasi"];
    let values: { [key: string]: string }[] = [];
    for (let i = 0; i < tableData.length; i++) {
      values.push({
        lokasi: tableData[i].lokasi,
      })
    }
    ExcelUtils.export(`Lokasi List on ${format(new Date(), "yyyy-MM-dd")}`, column, values);
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await LokasiService.GetAllLokasi();
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Master Lokasi"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                  <button className="cardButton" onClick={() => handleAddNew()} >
                    Add New
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => handleGenerateExcel()} >
                    Generate Excel
                  </button>
                </div>
              </div>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
              </div>
            </>
          }
        />
        <div
          style={{
            height: "65vh",
            overflow: "auto"
          }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Lokasi</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => {
                    return <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{row.lokasi}</td>
                      <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /> Edit</td>
                    </tr>
                  })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>

        {/* Popup Detail */}
        <Popup
          setShowPopup={setShowPopup}
          showPopup={showPopup}
          popupTitle={selectedLokasi == null ? "Add New" : `Edit ${selectedLokasi?.lokasi}`}
          popupContent={
            selectedLokasi == null ?
              <>
                <div className={css.form}>
                  <div className={css.containerleftright}>
                    <div className={css.leftposition}>
                      <div className={css.label}> Lokasi <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedAddLokasi?.lokasi ?? ""}
                        onChange={(event) => {
                          setSelectedAddLokasi((prevState: AddLokasiEntity | null) => {
                            return new AddLokasiEntity({
                              ...prevState,
                              lokasi: event.target.value
                            })
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className={css.buttons2}>
                    <div className={css.left}>
                      <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                        Close
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="primaryButton"
                        onClick={() => { handleSaveAddLokasi() }} >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </>
              : <>
                <div className={css.form}>
                  <div className={css.containerleftright}>
                    <div className={css.leftposition}>
                      <div className={css.label}> Lokasi <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedLokasi?.lokasi ?? ""}
                        onChange={(event) => {
                          setSelectedLokasi((prevState: LokasiEntity | null) => {
                            if (prevState == null) {
                              return null;
                            } else {
                              return new LokasiEntity({
                                ...prevState,
                                lokasi: event.target.value
                              })
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className={css.buttons2}>
                    <div className={css.left}>
                      <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                        Close
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="secondaryButton" onClick={() => handleDeleteLokasi()}>
                        Delete
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="primaryButton"
                        onClick={() => { handleSaveUpdateLokasi() }} >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </>
          }
        />
      </div>
    </>
  );
}
